import { Query } from '@tanstack/react-query';
import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import {
  GetCustomerActivityFeedParams,
  GetOrderActivityFeedParams,
  GetTargetActivityFeedParams,
} from './activityFeed.types';

export const CUSTOMER_ACTIVITY_FEED_KEY_ROOT = 'activity-feed/customers/:customerId';

export const ORDER_ACTIVITY_FEED_KEY_ROOT = 'activity-feed/orders/:orderId';

interface MatchActivityFeedQueryParams {
  keyRoot: string;
  entityId: string;
  teamId?: string;
}

export const matchActivityFeedQuery =
  ({ keyRoot, entityId, teamId }: MatchActivityFeedQueryParams) =>
  ({ queryKey }: Query) =>
    queryKey[0] === teamId && queryKey.includes(keyRoot) && queryKey.includes(entityId);

export const getCustomerActivityFeedKey = ({
  customerId,
  ...filters
}: GetCustomerActivityFeedParams): UseDataQuery['queryKey'] => [
  CUSTOMER_ACTIVITY_FEED_KEY_ROOT,
  customerId,
  filters,
];

export const getOrderActivityFeedKey = ({
  orderId,
  ...filters
}: GetOrderActivityFeedParams): UseDataQuery['queryKey'] => [
  ORDER_ACTIVITY_FEED_KEY_ROOT,
  orderId,
  filters,
];

export const getTargetActivityFeedKey = ({
  targetId,
  ...filters
}: GetTargetActivityFeedParams): UseDataQuery['queryKey'] => [
  'activity-feed/targets/:targetId',
  targetId,
  filters,
];
